import {GET_LAST_MODULE_RENDER} from '@/components/configuration/redux/types/ConfigurationTypes';

export const getLastModuleRender = (module) => {
    return {
        type: GET_LAST_MODULE_RENDER,
        value: module,
    };
};
